import React from 'react';

import DeleteStatusDialog from './DeleteStatusDialog';
import DeleteTaskDialog from './DeleteTaskDialog';
import StatusFormDialog from './StatusFormDialog';
import TaskFormDialog from './TaskFormDialog';

const Dialogs = () => (
  <>
    <DeleteStatusDialog />
    <DeleteTaskDialog />
    <StatusFormDialog />
    <TaskFormDialog />
  </>
);

export default Dialogs;
